<template>
  <div class="PageBox" style="padding-bottom: 52px">
    <div class="ScrollBox">
		<van-nav-bar
		    fixed
		    :border="false"
		    :title="$t('postRecord[0]')"
		    left-arrow
		    @click-left="$router.go(-1)"
		/>
      <van-form label-width="70">
        <van-field
            :border="false"
            v-model.trim="postData.title"
            rows="1"
            autosize
            :label="$t('postTask[0]')"
            type="textarea"
            :placeholder="$t('postTask[3]')"
        />
        <van-field
            :label="$t('postTask[1]')"
        >
          <template #input>
            <van-uploader class="Example" v-model="fileList" max-count="4" image-fit="contain" :after-read="afterRead" />
          </template>
        </van-field>
		<van-button block type="danger" style="font-size: 16px;background: #5a9947;margin-top: 15px;" @click="onSubmit">{{$t('postTask[2]')}}</van-button>
      </van-form>
    </div>
		<Footer />
  </div>
</template>

<script>
export default {
  name: 'postTask',
  components: {
  },
  props: [],
  data() {
    return {
      fileList: [],
      postData: {
        title: '',
        examine_demo: '',
      },
    }
  },
  computed: {

  },
  watch: {

  },
  created() {
	this.navBarTitle = this.$t('postTask.navBar.title')
  },
  mounted() {

  },
  activated() {

  },
  destroyed() {

  },
  methods: {
    afterRead(file) {
      file.status = 'uploading';
      file.message = this.$t('upload[0]')
      this.uploadImgs(file);
    },
    uploadImgs(file){
      if (!file.file.type.match(/image/)){
        file.status = 'failed'
        file.message = this.$t('upload[1]')
        return;
      }
      this.$Util.CompressImg(file.file.type,file.content,750,(image)=>{
        let param = new FormData();
        param.append('token',localStorage['Token']);
        param.append('type',3);
        param.append('image',image,file.file.name);
        this.$Model.UploadImg(param,(data)=>{
          if(data.code==1){
            file.message = this.$t('upload[2]')
            file.status = 'success'
            file.url = data.url
          }else{
            file.status = 'failed'
            file.message = this.$t('upload[3]')
          }
        });
      })
    },
    onSubmit() {
      if(!this.postData.title){
        this.$Dialog.Toast(this.$t('postTask.field[1].error'));
        return
      }
      if(this.fileList.length){
        this.postData.examine_demo = this.fileList.flatMap(item=>item.url)
      }else{
        this.postData.examine_demo = ''
      }
      this.$Model.PullPostTask(this.postData,data=>{
		  if(data.code == 1) {
			  this.postData = {
			    title: '',
			    examine_demo: '',
			  }
			  this.fileList = [];
			  this.$router.push("/postRecord");
		  }
			  //this.$Dialog.Toast(data.code_dec);
      })
    },
  }
}
</script>
<style scoped>
.van-form{
  padding: 10px;
}

.van-form .van-field{
  background-color: #f4f4f4;
  border-radius: 8px;
  margin-top: 10px;
  padding: 10px;
}
.van-form ::v-deep .van-field__label{
  color: #999;
}
.van-form ::v-deep .van-field__control--custom{
  min-height: auto;
}
.van-dropdown-menu{
  width: 100%;
}
.van-dropdown-menu ::v-deep .van-dropdown-menu__bar{
  background: transparent;
  box-shadow: none;
  height: auto;
}
.van-dropdown-menu ::v-deep .van-dropdown-menu__title{
  font-size: 14px;
  width: 100%;
  padding: 0;
}
.van-dropdown-menu ::v-deep .van-dropdown-menu__title::after{
  border-color: transparent transparent #888 #888;
  right: 0;
}
.van-checkbox-group{
  display: flex;
  white-space: nowrap;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
}
.van-checkbox-group ::v-deep .van-icon{
  display: none;
}
.van-checkbox-group ::v-deep .van-checkbox__label{
  margin: 3px 0;
  border: 1px #bbb solid;
  padding: 2px 5px;
  border-radius: 3px;
  font-size: 12px;
  color: #888;
}
::v-deep .van-nav-bar__title{
	color: #fff;
}
.van-checkbox-group ::v-deep .van-checkbox__icon--checked~.van-checkbox__label{
  color: #fff;
  background-color: #dd6161;
  border-color: #dd6161;
}
.Example ::v-deep .van-uploader__wrapper{
  width: 105%;
}
.Example ::v-deep .van-uploader__upload{
  background-color: #fff;
  margin: 4px 8px 4px 0;
}
.Example ::v-deep .van-uploader__preview{
  margin: 4px 8px 4px 0;
}
.van-uploader ::v-deep .van-uploader__upload,.van-uploader ::v-deep .van-uploader__preview-image{
  width: 60px;
  height: 60px;
}

.Steps{
  padding: 10px;
}
.Steps .tag{
  width: 30px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  background-color: #4087f1;
  color: #fff;
  border-radius: 100%;
  margin-right: 10px;
}
.Steps ::v-deep .van-uploader{
  vertical-align: top;
}
.Steps ::v-deep .van-uploader__upload,.Steps ::v-deep .van-uploader__preview{
  margin: 0;
}
.Steps .van-cell__title,.Steps .van-cell__value{
  flex: none;
}
.Steps .van-cell__value{
  margin-left: 10px;
  flex: auto;
}
.Steps .van-cell__value textarea{
  width: 100%;
  min-height: 60px;
  border: 1px #ddd solid;
  display: block;
  padding: 0 5px;
  font-size: 12px;
}
.Tips{
  font-size: 12px;
  margin-top: 10px;
}
.Tips ::v-deep a{
  color: #1989fa;
}
</style>